import React from 'react';
import CellRenderer from './cells/CellRenderer';
import RecordsActionMenu from './RecordsActionMenu';

export default function RecordsRow({
  row, columns, selected, onSelect,
  editingCell, savingCell, onStartEdit, onCancelEdit, onSaveEdit,
  formato, format_category, estados, users, procesos, positions, domain, custom_view_id,
  configuration_format, onSendEmails, onViewConfirmations, onRefresh,
  froalaConfig
}) {
  return (
    <tr className={selected ? 'cm-row--selected' : ''}>
      <td className="cm-dt-actions">
        <RecordsActionMenu
          row={row}
          formato={formato}
          format_category={format_category}
          estados={estados}
          domain={domain}
          configuration_format={configuration_format}
          onSendEmails={onSendEmails}
          onViewConfirmations={onViewConfirmations}
          onRefresh={onRefresh}
          custom_view_id={custom_view_id}
        />
      </td>
      <td className="cm-dt-check">
        <input
          type="checkbox"
          className="cm-checkbox"
          checked={selected}
          onChange={() => onSelect(row.id)}
        />
        {/* Visibilidad restringida: solo lo ven los usuarios autorizados del registro,
            quien lo creo y el Administrador Sistema (app/services/record_privacy.rb) */}
        {row.private && (
          <i
            className="fas fa-lock ml-1"
            style={{ fontSize: '11px', color: '#98a2b3' }}
            title="Este registro solo lo ven los usuarios autorizados en el formulario"
          ></i>
        )}
      </td>
      {columns.map(col => {
        const cell = row.cells[col.id.toString()] || { v: '' };
        const isEditing =
          editingCell &&
          editingCell.surveyId === row.id &&
          editingCell.questionId === col.id;
        const isSaving =
          savingCell &&
          savingCell.surveyId === row.id &&
          savingCell.questionId === col.id;

        const hasCellColor = cell.s ? (cell.s.bg && cell.s.bg !== 'none' && cell.s.bg !== 'white') : (cell.color && cell.color !== 'white');
        const badgeStyle = cell.s
          ? { background: cell.s.bg, color: cell.s.color }
          : cell.color && cell.color !== 'white'
            ? { background: cell.color, color: '#fff' }
            : null;

        const rendererProps = {
          cell,
          column: col,
          isEditing,
          onStartEdit: () => onStartEdit(row.id, col.id),
          onCancel: onCancelEdit,
          onSave: (value, selectItems) => onSaveEdit(row.id, col.id, value, selectItems),
          users,
          procesos,
          positions,
          froalaConfig,
          formato,
          format_category
        };

        return (
          <td
            key={col.id}
            className={`cm-cell${col.editable ? ' cm-cell--editable' : ''}${isSaving ? ' cm-cell--saving' : ''}`}
            style={col.type === 'answer_string' ? { whiteSpace: 'normal', overflow: 'visible', textOverflow: 'unset', wordBreak: 'break-word', maxWidth: 300 } : undefined}
          >
            {isSaving ? (
              <span className="cm-cell-saving"><i className="fas fa-spinner fa-spin" /></span>
            ) : isEditing ? (
              <CellRenderer {...rendererProps} />
            ) : hasCellColor ? (
              <span className="cm-cell-badge" style={col.type === 'answer_string' ? { ...badgeStyle, whiteSpace: 'normal', wordBreak: 'break-word' } : badgeStyle}>
                <CellRenderer {...rendererProps} />
              </span>
            ) : (
              <CellRenderer {...rendererProps} />
            )}
          </td>
        );
      })}
    </tr>
  );
}
